import React, { useState, useEffect } from 'react'
import { Container, AppBar, Typography, Grow, Grid, Toolbar } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { getPosts } from './actions/posts';
import memories from './img/memories.jpg';
import Posts from './components/Posts/Posts';
import Form from './components/Form/Form';
import useStyles from './styles';

function App() {
  const [currentId, setCurrentId] = useState(null);
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch])

  return (
    <Container maxWidth="lg">
        <AppBar className={classes.appBar} position="static" color="inherit">
            <Typography className={classes.heading} variant="h4" align="center">Memories</Typography>
            <img className={classes.img} src={memories} alt="memories" height="60"/>
        </AppBar>
      <Grow in>
        <Container maxWidth="lg">
          <Grid className={classes.mainContainer} container justify="space-between" align-items="stretch" spacing={3}>
            <Grid item xs={12} sm={7}>
              <Posts setCurrentId={setCurrentId} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Form currentId={currentId} setCurrentId={setCurrentId} />
            </Grid>
          </Grid>
        </Container> 
      </Grow>
    </Container>
  );
}

export default App

